module.exports = __webpack_public_path__ + "static/media/health.de9d116b.jpeg";